import ProductInformation from "./ProductInformation";
import PropTypes from "prop-types";
import compose from "recompose/compose";
import mapProps from "recompose/mapProps";
import withMediaQueries from "../../hocs/withMediaQueries";
import { localiseUrl } from "src/common/utils/format-localised-url";
import { withModel } from "../../data-providers/model";
import scrollTo from "../../utils/scrollTo";
import withProduct from "../../hocs/withProduct";

export const productInfoPropTypes = PropTypes.shape({
  image: PropTypes.object.isRequired,
  tabTitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.array.isRequired,
});

const handleClick = (link, countryModel) => () => {
  if (!link.startsWith("/")) {
    scrollTo(link);
  } else {
    window.location = localiseUrl(countryModel, link);
  }
};

const enhance = compose(
  withProduct,
  withMediaQueries,
  withModel,
  mapProps(({ model, ...props }) => ({
    countryModel: model.countryModel,
    handleClick,
    ...props,
  }))
);

export default enhance(ProductInformation);
